import { z } from "zod";

const SystemInitStateSchema = z.object({
  zipName: z.string(),
  loadingSubmit: z.boolean(),
});

export type SystemInitState = z.infer<typeof SystemInitStateSchema>;
